/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
const ChatSmallIcon = ({ size, ...props }) => (React.createElement("svg", { viewBox: "0 0 9 9", fill: "currentColor", width: size || '9', height: size || '9', ...props },
    React.createElement("path", { fill: "currentColor", d: "M9 6v2.594a.3.3 0 0 1-.488.233L6.242 7H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v5z", fillRule: "evenodd" })));
ChatSmallIcon.displayName = 'ChatSmallIcon';
export default ChatSmallIcon;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ChatSmallIcon.js.map